/**
 * 旧 Cognito ログイン（aws-amplify の CookieStorage）が残した Cookie を消す。
 *
 * API ログインへ切り替えた後も、切替前にログインしたブラウザには
 * `CognitoIdentityServiceProvider.<clientId>.*` の Cookie（Domain = apex、365 日）が残る。
 * api は legacy Cookie の受理期間中これで認証するため、`DELETE /v1/auth/session` だけでは
 * ログアウトしても次のリクエストで再び認証されてしまう（共用端末でログアウト済みと誤認する）。
 * Amplify の `signOut()` が担っていた Cookie 削除をここで肩代わりする。
 *
 * HttpOnly ではない（Amplify が JS から読み書きしていた）ため document.cookie から消せる。
 */

const LEGACY_COOKIE_PREFIX = 'CognitoIdentityServiceProvider.'

/** document.cookie から legacy Cognito Cookie の名前を列挙する。 */
export const listLegacyCognitoCookieNames = (): string[] =>
  document.cookie
    .split(';')
    .map((pair) => pair.split('=')[0].trim())
    .filter((name) => name.startsWith(LEGACY_COOKIE_PREFIX))

/**
 * legacy Cognito Cookie をすべて失効させる。
 *
 * Cookie は発行時と同じ Domain / Path を指定しないと消えない。Amplify は
 * `JIZAIPAD_DOMAIN`（apex）で書いていたが、ローカルなど Domain 無しで書かれた可能性もあるため
 * Domain 付きと Domain 無し（host-only）の両方を消す。
 */
export const clearLegacyCognitoCookies = (): void => {
  const domain = process.env.JIZAIPAD_DOMAIN
  const expired = 'expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'

  for (const name of listLegacyCognitoCookieNames()) {
    document.cookie = `${name}=; ${expired}`
    if (domain != null && domain !== '' && domain !== 'localhost') {
      document.cookie = `${name}=; ${expired}; domain=${domain}`
    }
  }
}
